// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const deskHome = process.env.REACT_APP_DESK_HOME || '';
const stayInPopup = window.location.pathname.startsWith('/auth/desk-done')
    || window.location.pathname.startsWith('/auth/microsoft-callback');
const deskEmbed = new URLSearchParams(window.location.search).get('desk_embed') === '1';
// Only bounce when HR is opened alone in a browser tab — not when Desk embeds it.
if (deskHome && window.self === window.top && !window.opener && !stayInPopup && !deskEmbed) {
    window.location.replace(`${deskHome.replace(/\/$/, '')}/modules/hr`);
}

console.log("index.js: Starting ZTask app initialization...");

const rootElement = document.getElementById('root');
if (!rootElement) {
    console.error("index.js: Root element not found! Check index.html.");
} else {
    console.log("index.js: Root element found, mounting App...");
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
    console.log("index.js: App mounted successfully.");
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();